import { FreeTextInput, FreeTextInputProps } from "../FreeTextInput/FreeTextInput"

export const ShortTextQuestion = (props: FreeTextInputProps) => {
    return <FreeTextInput {...props} />
}
